import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/empty.png'


const _hoisted_1 = {
  key: 0,
  class: "job-empty-content"
}

import dayjs from 'dayjs'
import { request } from '../../api/request';

import { onMounted, watch, ref } from 'vue'
// 组件
import { ElCollapse, ElPagination } from 'element-plus';
import ContentHeader from './content-header.vue';
import CollapseItem from './collapse-item.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'content-list',
  props: {
    city: {},
    jobName: {}
  },
  setup(__props: any) {

const props = __props

const jobList = ref([])
const page = ref(1)
const total = ref(0)

/** 监听 */
watch(
  () => props.city,
  () => {
    page.value = 1
    getJobList()
  }
)

watch(
  () => props.jobName,
  () => {
    page.value = 1
    getJobList()
  }
)

const getJobList = async () => {
  try {
    const params = {
      jobName: props.jobName || '',
      city: props.city || '全国',
      page: page.value,
      pageSize: 10
    }
    const res = await request("web.cms.pcWeb.query.job", params)
    console.log(res, 'job-list')
    jobList.value = res?.rows || []
    total.value = res?.rowTotal || 0
  } catch (e) {
    console.log(e)
  }
}

const currentChange = (val) => {
  page.value = +val
  console.log(val, 'currentChange')
  getJobList()
}

// 计算是否近3天发布的职位
const isHasNewFlag = (item) => {
  const today = dayjs()
  const targetDate = dayjs(item.publishTime)
  const diffInDays = today.diff(targetDate, 'day')
  console.log('diffInDays', diffInDays)
  return diffInDays <= 3
}

onMounted(() => {
  getJobList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ContentHeader),
    _createVNode(_unref(ElCollapse), { accordion: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value, (item) => {
          return (_openBlock(), _createBlock(CollapseItem, {
            id: item.jobId,
            name: item.jobName,
            date: item.publishTime,
            location: item.city,
            text: item.detail,
            key: item.jobId,
            educationRequired: item.educationRequired,
            "new-flag": isHasNewFlag(item)
          }, null, 8, ["id", "name", "date", "location", "text", "educationRequired", "new-flag"]))
        }), 128))
      ]),
      _: 1
    }),
    (!jobList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1),
          _createElementVNode("p", null, "搜索无结果~", -1)
        ])))
      : _createCommentVNode("", true),
    (jobList.value.length)
      ? (_openBlock(), _createBlock(_unref(ElPagination), {
          key: 1,
          class: "job-pagination",
          background: "",
          layout: "prev, pager, next",
          page: Number(page.value),
          total: total.value,
          onCurrentChange: currentChange
        }, null, 8, ["page", "total"]))
      : _createCommentVNode("", true)
  ]))
}
}

})